import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import PageShell from "../dashboard/PageShell";
import {
  OrganizationBasicInfo,
  OrganizationContactInfo,
  OrganizationFileUpload,
  OrganizationFormActions,
} from "../../components/forms/OrganizationForm";

const EditOrganization: React.FC = () => {
  const location = useLocation() as { state?: any };
  const id = useMemo(() => {
    const parts = window.location.pathname.split("/");
    return parts[parts.length - 1] || "";
  }, []);

  const [formData, setFormData] = useState({
    organizationName: "",
    englishName: "",
    classification: "",
    address: "",
    email: "",
    phone: "",
    country: "",
    contactPerson: "",
    contactPhone: "",
    contactEmail: "",
    notes: "",
    attachedFiles: [] as File[],
  });

  useEffect(() => {
    // Prefill from navigation state if provided
    if (location.state && location.state.prefill) {
      setFormData((prev) => ({
        ...prev,
        ...location.state.prefill,
      }));
    }
  }, [location.state]);

  const handleInputChange = (field: string, value: string | File[]) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    console.log("Updating organization id=", id, "data:", formData);
    // TODO: Implement update functionality
  };

  return (
    <PageShell title="Sửa tổ chức">
      <div className="space-y-4">
        {/* Header Section */}
        <div className="flex justify-between items-center">
          <h1 className="text-xl font-semibold text-gray-800">Sửa tổ chức</h1>
        </div>

        {/* Form Section */}
        <div className="bg-white rounded-lg p-4">
          <div className="space-y-4">
            <OrganizationBasicInfo
              formData={formData}
              handleInputChange={handleInputChange}
            />

            <OrganizationContactInfo
              formData={formData}
              handleInputChange={handleInputChange}
            />

            <OrganizationFileUpload
              formData={formData}
              handleInputChange={handleInputChange}
            />
          </div>
        </div>

        <OrganizationFormActions
          onSave={handleSave}
          onCancel={() => window.history.back()}
        />
      </div>
    </PageShell>
  );
};

export default EditOrganization;
